/**
 * Helpers to turn a stored cellular number into share links. We never send messages from a
 * server — the GM taps these to open WhatsApp / their SMS app with the text pre-filled.
 */

/** Keep only digits (drop +, spaces, dashes) — the form wa.me expects. */
export function sanitizePhone(phone: string): string {
  return (phone || '').replace(/[^\d]/g, '');
}

export function hasPhone(phone?: string): boolean {
  return !!phone && sanitizePhone(phone).length >= 6;
}

/** WhatsApp deep-link (wa.me) with a pre-filled message. */
export function whatsappLink(phone: string, text: string): string {
  return `https://wa.me/${sanitizePhone(phone)}?text=${encodeURIComponent(text)}`;
}

/** sms: deep-link with a pre-filled body (works on Android and modern iOS). */
export function smsLink(phone: string, body: string): string {
  return `sms:${(phone || '').replace(/\s+/g, '')}?body=${encodeURIComponent(body)}`;
}
